import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'zeroAreEmpty',
    standalone: true
})
export class ZeroAreEmptyPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if (this.isNumeric(value) && value == 0){
      return '';
    }

    return value;
  }

  private isNumeric(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    return !isNaN(value) && !isNaN(parseFloat(value));
  }

}
